export const GET_ARTICLES = 'HOME/GET_ARTICLES'
export const GET_ARTICLES_SUCCESS = 'HOME/GET_ARTICLES_SUCCESS'
export const GET_ARTICLES_FAIL = 'HOME/GET_ARTICLES_FAIL'

